import { END_POINT_STORAGE } from "./apiEndPoints";
import ApiManager from "./apiManager";
import { IUploadUrl, IReadUrl } from "src/models/storage";

export class StorageApi {
  async postUploadUrl(data: IUploadUrl): Promise<any> {
    const res = await ApiManager.post(`${END_POINT_STORAGE}/upload-url`, data);
    if (res) {
      return res;
    }
    return undefined;
  }

  async getReadUrl(fileName : string): Promise<IReadUrl> {
    const res = await ApiManager.get(`${END_POINT_STORAGE}/read-url?fileName=${fileName}`);
    if (res) {
      return res;
    }
    return undefined;
  }
}

export default new StorageApi();
